export const sentences = {

  "1": {
    "sententce_ID": 1,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": "Mike"
    },
    "2": {
      "word": "",
      "word_top": "am\u3000",
      "word_bottom": "am"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I am Mike.",
    "sentence_len": 2
  },
  "2": {
    "sententce_ID": 2,
    "1": {
      "word": "",
      "word_top": "You",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "are\u3000",
      "word_bottom": "are"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "from",
      "word_bottom": "Australia"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "You are from Australia.",
    "sentence_len": 3
  },
  "3": {
    "sententce_ID": 3,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "My name",
      "word_bottom": "Yamada Ichiro"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "My name is Yamada Ichiro.",
    "sentence_len": 2
  },
  "4": {
    "sententce_ID": 4,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": " "
    },
    "2": {
      "word": "",
      "word_top": "do\u3000like",
      "word_bottom": "like"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "strawberries"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I like strawberries.",
    "sentence_len": 3
  },
  "5": {
    "sententce_ID": 5,
    "1": {
      "word": "",
      "word_top": "We",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "do\u3000like",
      "word_bottom": "like"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "soccer"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "We like soccer.",
    "sentence_len": 3
  },
  "6": {
    "sententce_ID": 6,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "Today",
      "word_bottom": "your birthday"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Today is your birthday.",
    "sentence_len": 2
  },
  "7": {
    "sententce_ID": 7,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": "Kumi"
    },
    "2": {
      "word": "",
      "word_top": "am\u3000",
      "word_bottom": "am"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I am Kumi.",
    "sentence_len": 2
  },
  "8": {
    "sententce_ID": 8,
    "1": {
      "word": "",
      "word_top": "Mike",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "from",
      "word_bottom": "New Zealand"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Mike is from New Zealand.",
    "sentence_len": 3
  },
  "9": {
    "sententce_ID": 9,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "do\u3000swim",
      "word_bottom": "swim"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "in",
      "word_bottom": "the sea"
    },
    "6": {
      "word": "",
      "word_top": "in",
      "word_bottom": "summer"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I swim in the sea in summer.",
    "sentence_len": 4
  },
  "10": {
    "sententce_ID": 10,
    "1": {
      "word": "",
      "word_top": "Alex",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "does\u3000like",
      "word_bottom": "likes"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "Chinese food"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Mike likes Chinese food.",
    "sentence_len": 3
  },
  "11": {
    "sententce_ID": 11,
    "1": {
      "word": "",
      "word_top": "Taro",
      "word_bottom": "Japanese"
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Taro is Japanese.",
    "sentence_len": 2
  },
  "12": {
    "sententce_ID": 12,
    "1": {
      "word": "",
      "word_top": "Emily",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "from",
      "word_bottom": "the U.S"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Emily is from the U.S.",
    "sentence_len": 3
  },
  "13": {
    "sententce_ID": 13,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "My birthday",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "2001-05-14 00:00:00"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "My birthday is May 14. ",
    "sentence_len": 3
  },
  "14": {
    "sententce_ID": 14,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "are\u3000",
      "word_bottom": "are"
    },
    "3": {
      "word": "",
      "word_top": "These apples",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " yellow",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "These apples are yellow.",
    "sentence_len": 3
  },
  "15": {
    "sententce_ID": 15,
    "1": {
      "word": "",
      "word_top": "You",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "are\u3000",
      "word_bottom": "are"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "a hero"
    },
    "4": {
      "word": "",
      "word_top": "    ",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "in",
      "word_bottom": "Japan"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "You are a hero in Japan.",
    "sentence_len": 5
  },
  "16": {
    "sententce_ID": 16,
    "1": {
      "word": "",
      "word_top": "We",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "do\u3000want",
      "word_bottom": "want"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "fresh fruits"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "We want fresh fruits.",
    "sentence_len": 3
  },
  "17": {
    "sententce_ID": 17,
    "1": {
      "word": "",
      "word_top": "You",
      "word_bottom": "Kumi"
    },
    "2": {
      "word": "",
      "word_top": "are\u3000",
      "word_bottom": "are"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "           ",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "You are Kumi.",
    "sentence_len": 3
  },
  "18": {
    "sententce_ID": 18,
    "1": {
      "word": "",
      "word_top": "We",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "do\u3000eat",
      "word_bottom": "eat"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "two bananas"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "for dessert",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "We eat two bananas for dessert.",
    "sentence_len": 4
  },
  "19": {
    "sententce_ID": 19,
    "1": {
      "word": "",
      "word_top": "Kumi and Taro",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "do\u3000study",
      "word_bottom": "study"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "English"
    },
    "4": {
      "word": "",
      "word_top": " very hard",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "every day"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Kumi and Takuya study English very hard every day.",
    "sentence_len": 5
  },
  "20": {
    "sententce_ID": 20,
    "1": {
      "word": "",
      "word_top": "Kumi",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "does\u3000eat",
      "word_bottom": "eats"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "natto"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "at",
      "word_bottom": "home"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "every morning"
    },
    "7": {
      "word": "",
      "word_top": "for her health",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Kumi eats natto at home every morning for her health.",
    "sentence_len": 6
  },
  "21": {
    "sententce_ID": 21,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "am\u3000reading",
      "word_bottom": "am reading"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "a book"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "in",
      "word_bottom": "my room"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I am reading a book in my room.",
    "sentence_len": 4
  },
  "22": {
    "sententce_ID": 22,
    "1": {
      "word": "",
      "word_top": "Ichiro",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000studying",
      "word_bottom": "is studying"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "math"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "at",
      "word_bottom": "school"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "now"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Ichiro is studying math at school now.",
    "sentence_len": 5
  },
  "23": {
    "sententce_ID": 23,
    "1": {
      "word": "",
      "word_top": "Kumi",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000drawing",
      "word_bottom": "is drawing"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "a picture of an orange."
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "in",
      "word_bottom": "the art room"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Kumi is drawing a picture of an orange in the art room.",
    "sentence_len": 4
  },
  "24": {
    "sententce_ID": 24,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "am\u3000listening to",
      "word_bottom": "am listening to"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "jazz music"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "at",
      "word_bottom": "the concert"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I am listening to jazz music at the concert.",
    "sentence_len": 4
  },
  "25": {
    "sententce_ID": 25,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "am\u3000buying",
      "word_bottom": "am buying"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "my lunch"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "at",
      "word_bottom": "a convinience store"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I am buying my lunch at a convinience store.",
    "sentence_len": 4
  },
  "26": {
    "sententce_ID": 26,
    "1": {
      "word": "",
      "word_top": "You",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "are\u3000sitting",
      "word_bottom": "are sitting"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "on",
      "word_bottom": "the chair"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "You are sitting on the chair.",
    "sentence_len": 3
  },
  "27": {
    "sententce_ID": 27,
    "1": {
      "word": "",
      "word_top": "Emily",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000singing",
      "word_bottom": "is singing"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "an English song"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "on",
      "word_bottom": "the stage"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Emily is singing an English song on the stage.",
    "sentence_len": 4
  },
  "28": {
    "sententce_ID": 28,
    "1": {
      "word": "",
      "word_top": "Kumi",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000writing",
      "word_bottom": "is writing"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "a diary"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "in",
      "word_bottom": "her room"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Kumi is writing a diary in her room.",
    "sentence_len": 4
  },
  "29": {
    "sententce_ID": 29,
    "1": {
      "word": "",
      "word_top": "The students",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "are\u3000cleaning",
      "word_bottom": "are cleaning"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "the classroom"
    },
    "4": {
      "word": "",
      "word_top": "very hard",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The students are cleaning the classroom very hard.",
    "sentence_len": 4
  },
  "30": {
    "sententce_ID": 30,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "am\u3000making",
      "word_bottom": "is making"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "bread"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "in",
      "word_bottom": "the kitichen"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "for breakfast",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I am making bread in the kitchen for breakfast.",
    "sentence_len": 5
  },
  "31": {
    "sententce_ID": 31,
    "1": {
      "word": "",
      "word_top": "My brother",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000running",
      "word_bottom": "is running"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "in",
      "word_bottom": "the park"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "for his diet",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "My brother is running in the park for her diet.",
    "sentence_len": 4
  },
  "32": {
    "sententce_ID": 32,
    "1": {
      "word": "",
      "word_top": "Police officers",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "are\u3000working",
      "word_bottom": "are working"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "on",
      "word_bottom": "the street"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "now"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Police officers are working on the street now.",
    "sentence_len": 4
  },
  "33": {
    "sententce_ID": 33,
    "1": {
      "word": "",
      "word_top": "Taro's grandfather",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000practicing",
      "word_bottom": "is practicing"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "his driving"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "at ",
      "word_bottom": "the driving school"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Taro's grandfather is practicing his driving at the driving school.",
    "sentence_len": 4
  },
  "34": {
    "sententce_ID": 34,
    "1": {
      "word": "",
      "word_top": "The hotel staff",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000standing",
      "word_bottom": "is standing"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "by",
      "word_bottom": "the entrance door"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The hotel staff is standing by the entrance door.",
    "sentence_len": 3
  },
  "35": {
    "sententce_ID": 35,
    "1": {
      "word": "",
      "word_top": "Alex",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000eatting",
      "word_bottom": "is eating"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "some  fruits"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "at",
      "word_bottom": "the restaurant"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Mike is eating some fruits at the restaurant.",
    "sentence_len": 4
  },
  "36": {
    "sententce_ID": 36,
    "1": {
      "word": "",
      "word_top": "Taro",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000watching",
      "word_bottom": "is watching"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "deer"
    },
    "4": {
      "word": "",
      "word_top": " carefully",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "in",
      "word_bottom": "the wood"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Taro is watching  deer carefully in the wood.",
    "sentence_len": 5
  },
  "37": {
    "sententce_ID": 37,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": "with my friends"
    },
    "2": {
      "word": "",
      "word_top": "am\u3000planing",
      "word_bottom": "am planning"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "a  trip to Hokkaido"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I am planning a trip to Hokkaido with my friends.",
    "sentence_len": 3
  },
  "38": {
    "sententce_ID": 38,
    "1": {
      "word": "",
      "word_top": "We",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "are\u3000drinking",
      "word_bottom": "are drinking"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "soda"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "at",
      "word_bottom": "the cafeteria"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "We are drinking soda at the cafeteria.",
    "sentence_len": 4
  },
  "39": {
    "sententce_ID": 39,
    "1": {
      "word": "",
      "word_top": "Ami",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000dancing",
      "word_bottom": "is dancing"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "breaking"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "on",
      "word_bottom": "the stage"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "now"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Ami is dancing breaking on the stage now.",
    "sentence_len": 5
  },
  "40": {
    "sententce_ID": 40,
    "1": {
      "word": "",
      "word_top": "Hiroko and her dog",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "are\u3000sleeping",
      "word_bottom": "are sleeping"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " comfortably",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "on",
      "word_bottom": "the grass"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Hiroko and her dog are sleeping comfortably on the grass.",
    "sentence_len": 4
  },
  "41": {
    "sententce_ID": 41,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "can\u3000make",
      "word_bottom": "can make"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "delicious doughnuts"
    },
    "4": {
      "word": "",
      "word_top": " easily",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "at",
      "word_bottom": "home"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "for a snack",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I can make delicious doughnuts easily at home for a snack.",
    "sentence_len": 6
  },
  "42": {
    "sententce_ID": 42,
    "1": {
      "word": "",
      "word_top": "My sister",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "can\u3000sing",
      "word_bottom": "can sing"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "German songs"
    },
    "4": {
      "word": "",
      "word_top": " very well",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "My sister can sing German songs very well.",
    "sentence_len": 4
  },
  "43": {
    "sententce_ID": 43,
    "1": {
      "word": "",
      "word_top": "The teacher",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "can\u3000dance",
      "word_bottom": "can dance"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "hip-hop"
    },
    "4": {
      "word": "",
      "word_top": " very well",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The teacher can dance hip-hop very well.",
    "sentence_len": 4
  },
  "44": {
    "sententce_ID": 44,
    "1": {
      "word": "",
      "word_top": "Kumi",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "can\u3000skateboard",
      "word_bottom": "skateboard"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Kumi can skateboard .",
    "sentence_len": 2
  },
  "45": {
    "sententce_ID": 45,
    "1": {
      "word": "",
      "word_top": "You",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "can\u3000see",
      "word_bottom": "can see"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "a lion"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "at",
      "word_bottom": "the zoo"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "You can see a lion at the zoo.",
    "sentence_len": 4
  },
  "46": {
    "sententce_ID": 46,
    "1": {
      "word": "",
      "word_top": "My grandfather",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "can\u3000cut",
      "word_bottom": "can cut"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "pineapples"
    },
    "4": {
      "word": "",
      "word_top": " quickly",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "My grandfather can cut pineapples quickly.",
    "sentence_len": 4
  },
  "47": {
    "sententce_ID": 47,
    "1": {
      "word": "",
      "word_top": "You",
      "word_bottom": "with your family"
    },
    "2": {
      "word": "",
      "word_top": "can\u3000have",
      "word_bottom": "can have"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "a fun time"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "You can have a fun time with your family.",
    "sentence_len": 3
  },
  "48": {
    "sententce_ID": 48,
    "1": {
      "word": "",
      "word_top": "Emily",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "can\u3000climb",
      "word_bottom": "can climb"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "high mountains"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Emily can clime high mountains.",
    "sentence_len": 3
  },
  "49": {
    "sententce_ID": 49,
    "1": {
      "word": "",
      "word_top": "Tomomi",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "can\u3000speak",
      "word_bottom": "can speak"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "Chinese"
    },
    "4": {
      "word": "",
      "word_top": " fluently",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Tomomi can speak Chinese fluently.",
    "sentence_len": 4
  },
  "50": {
    "sententce_ID": 50,
    "1": {
      "word": "",
      "word_top": "You",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "can\u3000play",
      "word_bottom": "can play"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "baseball"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "in",
      "word_bottom": "the park"
    },
    "6": {
      "word": "",
      "word_top": "on",
      "word_bottom": "Sundays"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "You can play baseball in the park on Sundays. ",
    "sentence_len": 5
  },
  "51": {
    "sententce_ID": 51,
    "1": {
      "word": "",
      "word_top": "This company",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "was\u3000able to make",
      "word_bottom": "was able to make"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "good cameras"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "10 years ago"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "This company was able to make  good cameras 10 years ago.",
    "sentence_len": 4
  },
  "52": {
    "sententce_ID": 52,
    "1": {
      "word": "",
      "word_top": "This machine",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000able to make",
      "word_bottom": "is able to make"
    },
    "3": {
      "word": "",
      "word_top": " ",
      "word_bottom": "1,000 products"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "in",
      "word_bottom": "an hour"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "This machine is able to make 1,000 products in an hour.",
    "sentence_len": 4
  },
  "53": {
    "sententce_ID": 53,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "are\u3000able to speak",
      "word_bottom": "are able to speak"
    },
    "3": {
      "word": "",
      "word_top": "These parrots",
      "word_bottom": "some words"
    },
    "4": {
      "word": "",
      "word_top": " clearly",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "These parrots are able to speak some words clearly.",
    "sentence_len": 3
  },
  "54": {
    "sententce_ID": 54,
    "1": {
      "word": "",
      "word_top": "The car",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is \u3000able to run",
      "word_bottom": "is able to run"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "at 15km/h",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The car is able to run at 150km/h.",
    "sentence_len": 3
  },
  "55": {
    "sententce_ID": 55,
    "1": {
      "word": "",
      "word_top": "Ken",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is \u3000able to pay",
      "word_bottom": "is able to pay"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "the charge"
    },
    "4": {
      "word": "",
      "word_top": "with his credit card",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Ken is able to pay the charge with his credit card.",
    "sentence_len": 4
  },
  "56": {
    "sententce_ID": 56,
    "1": {
      "word": "",
      "word_top": "Kumi",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "will\u3000be able to get",
      "word_bottom": "will be able to get"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "to",
      "word_bottom": "the station"
    },
    "6": {
      "word": "",
      "word_top": "in",
      "word_bottom": "a few minutes"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Kumi will be able to get to the station in a few minutes.",
    "sentence_len": 4
  },
  "57": {
    "sententce_ID": 57,
    "1": {
      "word": "",
      "word_top": "We",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "will\u3000able to get",
      "word_bottom": "will be able to get"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "a lot of money"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "next year"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "We will be able to get a lot of money next year.",
    "sentence_len": 4
  },
  "58": {
    "sententce_ID": 58,
    "1": {
      "word": "",
      "word_top": "Japanese people",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "must\u3000be able to feel",
      "word_bottom": "must be able to feel"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "for the sound of insects"
    },
    "4": {
      "word": "",
      "word_top": "  good",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Japanese people must be able to feel good for the sound of insects.",
    "sentence_len": 4
  },
  "59": {
    "sententce_ID": 59,
    "1": {
      "word": "",
      "word_top": "You",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "will\u3000be able to finish",
      "word_bottom": "will be able to finish"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "this homework"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "in",
      "word_bottom": "three hours"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "You will be able to finish this homework in three hours.",
    "sentence_len": 4
  },
  "60": {
    "sententce_ID": 60,
    "1": {
      "word": "",
      "word_top": "We",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "will\u3000be able to make",
      "word_bottom": "will be able to make"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "the earth"
    },
    "4": {
      "word": "",
      "word_top": " cleaner",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "for SDGs",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "We will be able to make the earth cleaner for SDGs.",
    "sentence_len": 5
  },
  "61": {
    "sententce_ID": 61,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "a big screen",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "There",
      "word_bottom": "in the office"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "There is a big screen in the office.",
    "sentence_len": 3
  },
  "62": {
    "sententce_ID": 62,
    "1": {
      "word": "",
      "word_top": "forty-one students",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "are\u3000",
      "word_bottom": "are"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "There",
      "word_bottom": "in my classroom"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "There are forty-one students in my classroom.",
    "sentence_len": 3
  },
  "63": {
    "sententce_ID": 63,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "are\u3000",
      "word_bottom": "are"
    },
    "3": {
      "word": "",
      "word_top": "many kinds of flowers",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "There",
      "word_bottom": "in the garden"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "There are many kinds of flowers in the garden.",
    "sentence_len": 3
  },
  "64": {
    "sententce_ID": 64,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "a Korean restaurant",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "There",
      "word_bottom": "over there"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "There is a Korean restaurant over there.",
    "sentence_len": 3
  },
  "65": {
    "sententce_ID": 65,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "a big shopping mall",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "There",
      "word_bottom": "in my town"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "There is a big shopping mall in my town.",
    "sentence_len": 3
  },
  "66": {
    "sententce_ID": 66,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "a steel kettle",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "There",
      "word_bottom": "in the kitchen"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "There is a steel kettle in the kitchen.",
    "sentence_len": 3
  },
  "67": {
    "sententce_ID": 67,
    "1": {
      "word": "",
      "word_top": "a lot of kind people",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "are\u3000",
      "word_bottom": "are"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "There",
      "word_bottom": "in this town"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "There are a lot of kind people in this town.",
    "sentence_len": 3
  },
  "68": {
    "sententce_ID": 68,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "are\u3000",
      "word_bottom": "are"
    },
    "3": {
      "word": "",
      "word_top": "many bathrooms",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "There",
      "word_bottom": "in this hotel"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "There are many bathrooms in this hotel.",
    "sentence_len": 3
  },
  "69": {
    "sententce_ID": 69,
    "1": {
      "word": "",
      "word_top": "a doctor",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "There",
      "word_bottom": "in this small village"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "There is a doctor in this small village.",
    "sentence_len": 3
  },
  "70": {
    "sententce_ID": 70,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "are\u3000",
      "word_bottom": "are"
    },
    "3": {
      "word": "",
      "word_top": "a lot of foxes",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "There",
      "word_bottom": "in the forest"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "There are a lot of foxes in the forest.",
    "sentence_len": 3
  },
  "71": {
    "sententce_ID": 71,
    "1": {
      "word": "",
      "word_top": "a cool young man",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": " ",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "There",
      "word_bottom": "in the room"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "There is a cool young man in the room.",
    "sentence_len": 4
  },
  "72": {
    "sententce_ID": 72,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "are\u3000",
      "word_bottom": "are"
    },
    "3": {
      "word": "",
      "word_top": "many dogs",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "There",
      "word_bottom": "in this pet shop"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "There are many dogs in this pet shop.",
    "sentence_len": 3
  },
  "73": {
    "sententce_ID": 73,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "a woman",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "There",
      "word_bottom": "in the office"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "There is a woman in the office.",
    "sentence_len": 3
  },
  "74": {
    "sententce_ID": 74,
    "1": {
      "word": "",
      "word_top": "many foreigners",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "are\u3000",
      "word_bottom": "are"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "There",
      "word_bottom": "in Japan"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "recently"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "There are many foreigners in Japan recently.",
    "sentence_len": 4
  },
  "75": {
    "sententce_ID": 75,
    "1": {
      "word": "",
      "word_top": "a handsome boy",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "There",
      "word_bottom": "in the classroom"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "There is a handsome boy in the classroom.",
    "sentence_len": 3
  },
  "76": {
    "sententce_ID": 76,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "was\u3000",
      "word_bottom": "was"
    },
    "3": {
      "word": "",
      "word_top": "a calendar",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "There",
      "word_bottom": "in my room"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "There was a calendar in my room last year.",
    "sentence_len": 3
  },
  "77": {
    "sententce_ID": 77,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "were\u3000",
      "word_bottom": "were"
    },
    "3": {
      "word": "",
      "word_top": "many trees",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "There",
      "word_bottom": "in the yard"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "ten years ago"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "There were many trees in the yard ten years ago.",
    "sentence_len": 4
  },
  "78": {
    "sententce_ID": 78,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "was\u3000",
      "word_bottom": "was"
    },
    "3": {
      "word": "",
      "word_top": "a passion",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "There",
      "word_bottom": "in every person's heart"
    },
    "6": {
      "word": "",
      "word_top": "at",
      "word_bottom": "that time"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "There was a passion in every person's heart at that time.",
    "sentence_len": 4
  },
  "79": {
    "sententce_ID": 79,
    "1": {
      "word": "",
      "word_top": "a lot of swimmers",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "were\u3000",
      "word_bottom": "were"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "There",
      "word_bottom": "in the sea"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "last week"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "There were a lot of swimmers in the sea last week.",
    "sentence_len": 4
  },
  "80": {
    "sententce_ID": 80,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "were\u3000",
      "word_bottom": "were"
    },
    "3": {
      "word": "",
      "word_top": "some cakes",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "There",
      "word_bottom": "in the fridge"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "this morning"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "There were some cakes in the fridge this morning.",
    "sentence_len": 4
  },
  "81": {
    "sententce_ID": 81,
    "1": {
      "word": "",
      "word_top": "Ichiro",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "did\u3000eat",
      "word_bottom": "ate"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "udon"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "in",
      "word_bottom": "his house"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "the day before yesterday"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Ichiro ate udon in his house the day before yesterday.",
    "sentence_len": 5
  },
  "82": {
    "sententce_ID": 82,
    "1": {
      "word": "",
      "word_top": "We",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "did\u3000have",
      "word_bottom": "had"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "delicious lunch"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "at",
      "word_bottom": "the restaurant"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "yesterday"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "We had delocious lunch at the restaurant yesterday.",
    "sentence_len": 5
  },
  "83": {
    "sententce_ID": 83,
    "1": {
      "word": "",
      "word_top": "Emily",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "did\u3000go",
      "word_bottom": "went"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "to the ",
      "word_bottom": "theater"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "last night"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Emily went to the theater last night.",
    "sentence_len": 4
  },
  "84": {
    "sententce_ID": 84,
    "1": {
      "word": "",
      "word_top": "Mike",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "was\u3000watching",
      "word_bottom": "was watching"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "an anime"
    },
    "4": {
      "word": "",
      "word_top": "on his smartphone",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "on",
      "word_bottom": "the bus"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "then"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Mike was watching an anime on his smartphone on the bus then.",
    "sentence_len": 6
  },
  "85": {
    "sententce_ID": 85,
    "1": {
      "word": "",
      "word_top": "We",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "did\u3000visit",
      "word_bottom": "visited"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": "Osaka Castle"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "last week"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "We visited Osaka Castle last week.",
    "sentence_len": 4
  },
  "86": {
    "sententce_ID": 86,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "did\u3000enjoy",
      "word_bottom": "enjoyed"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "Mike's birthday party"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "at",
      "word_bottom": "his house"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "last month"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I enjoyed Mike's birthday party at his house last month.",
    "sentence_len": 5
  },
  "87": {
    "sententce_ID": 87,
    "1": {
      "word": "",
      "word_top": "Kumi",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "did\u3000make",
      "word_bottom": "made"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "a quick breakfast"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "this morning"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Kumi made a quick breakfast this morning.",
    "sentence_len": 4
  },
  "88": {
    "sententce_ID": 88,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "did\u3000look",
      "word_bottom": "looked"
    },
    "3": {
      "word": "",
      "word_top": "The paintings",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " very beautiful",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "in",
      "word_bottom": "the museum"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The paintings looked very beautiful in the museum.",
    "sentence_len": 4
  },
  "89": {
    "sententce_ID": 89,
    "1": {
      "word": "",
      "word_top": "My brother",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "was\u3000",
      "word_bottom": "was"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "an idol fan"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "then"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "My brother was an idol fan then.",
    "sentence_len": 4
  },
  "90": {
    "sententce_ID": 90,
    "1": {
      "word": "",
      "word_top": "Emily",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "was\u3000running",
      "word_bottom": "was running"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " very fast",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "on",
      "word_bottom": "the street"
    },
    "6": {
      "word": "",
      "word_top": "at",
      "word_bottom": "9 pm last night"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Emily was running very fast on the street at 9:00 p.m last night.",
    "sentence_len": 5
  },
  "91": {
    "sententce_ID": 91,
    "1": {
      "word": "",
      "word_top": "Ichiro",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "did\u3000play",
      "word_bottom": "palyed"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "baseball"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "at",
      "word_bottom": "Koshien"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "three days ago"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Ichiro played baseball at Koshien three days ago.",
    "sentence_len": 5
  },
  "92": {
    "sententce_ID": 92,
    "1": {
      "word": "",
      "word_top": "We",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "were\u3000",
      "word_bottom": "were"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "table tennis players"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "three years ago"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "We were table tennis players three years ago.",
    "sentence_len": 4
  },
  "93": {
    "sententce_ID": 93,
    "1": {
      "word": "",
      "word_top": "Mike",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "did\u3000buy",
      "word_bottom": "bought"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "an expensive T-shirt"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "in",
      "word_bottom": "Hawaii"
    },
    "6": {
      "word": "",
      "word_top": "on",
      "word_bottom": "his trip"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Mike bought an expensive T-shirt in Hawaii on his trip.",
    "sentence_len": 5
  },
  "94": {
    "sententce_ID": 94,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "was\u3000doing",
      "word_bottom": "was doing"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "my homework"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "at ",
      "word_bottom": "six this morning"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I was doing my homework at six this morning.",
    "sentence_len": 4
  },
  "95": {
    "sententce_ID": 95,
    "1": {
      "word": "",
      "word_top": "Emily",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "was\u3000",
      "word_bottom": "was"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " sick",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "in",
      "word_bottom": "bed"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "last week"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Emily was sick in bed last week.",
    "sentence_len": 5
  },
  "96": {
    "sententce_ID": 96,
    "1": {
      "word": "",
      "word_top": "Kumi",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "did\u3000bake",
      "word_bottom": "baked"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "okara bread"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "at",
      "word_bottom": "home"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "yesterday"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Kumi baked okara bread at home yesterday.",
    "sentence_len": 5
  },
  "97": {
    "sententce_ID": 97,
    "1": {
      "word": "",
      "word_top": "The family",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "did\u3000come",
      "word_bottom": "came"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "to ",
      "word_bottom": "their new apartment"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "a week ago"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The family came to their new apartment a week ago.",
    "sentence_len": 4
  },
  "98": {
    "sententce_ID": 98,
    "1": {
      "word": "",
      "word_top": "You",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "were\u3000",
      "word_bottom": "were"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " very cool",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "on",
      "word_bottom": "that stage"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "last night"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "You were very cool on that stage last night.",
    "sentence_len": 5
  },
  "99": {
    "sententce_ID": 99,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "was\u3000using",
      "word_bottom": "was using"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "the computer"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "at",
      "word_bottom": "ten last night"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I was using the computer at ten last night.",
    "sentence_len": 4
  },
  "100": {
    "sententce_ID": 100,
    "1": {
      "word": "",
      "word_top": "The museum",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "was\u3000",
      "word_bottom": "was"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " interesting and useful",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The museum was interesting and useful.",
    "sentence_len": 3
  },
  "101": {
    "sententce_ID": 101,
    "1": {
      "word": "",
      "word_top": "I ",
      "word_bottom": "you"
    },
    "2": {
      "word": "",
      "word_top": "will\u3000help",
      "word_bottom": "will help"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "with your science report"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I will help you with your science report.",
    "sentence_len": 3
  },
  "102": {
    "sententce_ID": 102,
    "1": {
      "word": "",
      "word_top": "Kumi",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000 going to visit",
      "word_bottom": "is going to visit"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": "Canada"
    },
    "6": {
      "word": "",
      "word_top": "during",
      "word_bottom": "the summer vacation"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Kumi is going to visit Canada during the summer vacation.",
    "sentence_len": 4
  },
  "103": {
    "sententce_ID": 103,
    "1": {
      "word": "",
      "word_top": "We",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "must\u3000leave",
      "word_bottom": "must leave"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": "school"
    },
    "6": {
      "word": "",
      "word_top": "by",
      "word_bottom": "five o'clock"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "We must leave school by five o'clock.",
    "sentence_len": 4
  },
  "104": {
    "sententce_ID": 104,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "do\u3000have to finish",
      "word_bottom": "have to finish"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "my homework"
    },
    "4": {
      "word": "",
      "word_top": " quickly",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I have to finish my homework quickly.",
    "sentence_len": 4
  },
  "105": {
    "sententce_ID": 105,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "may\u3000fall down",
      "word_bottom": "may fall down"
    },
    "3": {
      "word": "",
      "word_top": "The shelf ",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "in",
      "word_bottom": "an earthquake"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The shelf may fall down in an earthquake.",
    "sentence_len": 3
  },
  "106": {
    "sententce_ID": 106,
    "1": {
      "word": "",
      "word_top": "We",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "should\u3000hold",
      "word_bottom": "should hold"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "a meeting"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "every Monday"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "We should hold a meeting every Monday.",
    "sentence_len": 4
  },
  "107": {
    "sententce_ID": 107,
    "1": {
      "word": "",
      "word_top": "You",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "will\u3000see",
      "word_bottom": "will see"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "new elephants"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "at",
      "word_bottom": "the zoo"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "next month"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "You will see new elephants at the zoo next month. ",
    "sentence_len": 5
  },
  "108": {
    "sententce_ID": 108,
    "1": {
      "word": "",
      "word_top": "My family",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000going",
      "word_bottom": "is going"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "on a business trip"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "next week"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "My father is going on a business trip next week.",
    "sentence_len": 4
  },
  "109": {
    "sententce_ID": 109,
    "1": {
      "word": "",
      "word_top": "We",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "must\u3000stay",
      "word_bottom": "must stay"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " calm",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "in",
      "word_bottom": "the robby of the hotel"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "We must stay calm in the robby of the hotel.",
    "sentence_len": 4
  },
  "110": {
    "sententce_ID": 110,
    "1": {
      "word": "",
      "word_top": "Emily",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "does\u3000have to go",
      "word_bottom": "has to go"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "to",
      "word_bottom": "school"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "tomorrow"
    },
    "7": {
      "word": "",
      "word_top": "for the test",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Emily has to go to school tomorrow for the test.",
    "sentence_len": 5
  },
  "111": {
    "sententce_ID": 111,
    "1": {
      "word": "",
      "word_top": "We",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "may\u3000move",
      "word_bottom": "may move"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "to",
      "word_bottom": "Okayama"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "next year"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "We may move to Okayama next year.",
    "sentence_len": 4
  },
  "112": {
    "sententce_ID": 112,
    "1": {
      "word": "",
      "word_top": "We",
      "word_bottom": "our pets"
    },
    "2": {
      "word": "",
      "word_top": "should\u3000love",
      "word_bottom": "should love"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "with all our hearts",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "We should love our pets with all our hearts.",
    "sentence_len": 3
  },
  "113": {
    "sententce_ID": 113,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "will\u3000start",
      "word_bottom": "will start"
    },
    "3": {
      "word": "",
      "word_top": "The movie",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "at",
      "word_bottom": "the ABC Theater"
    },
    "6": {
      "word": "",
      "word_top": "at",
      "word_bottom": "11 o'clock"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The movie will start at the ABC Theater at 11 o'clock.",
    "sentence_len": 4
  },
  "114": {
    "sententce_ID": 114,
    "1": {
      "word": "",
      "word_top": "Mike",
      "word_bottom": "with his friends"
    },
    "2": {
      "word": "",
      "word_top": "is\u3000going to go",
      "word_bottom": "is going to go"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "to",
      "word_bottom": "the zoo"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "next Sunday"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Mike is going to go to the zoo next Sunday with his friends.",
    "sentence_len": 4
  },
  "115": {
    "sententce_ID": 115,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "must\u3000study",
      "word_bottom": "must study"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " hard",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "today"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I must study English hard today.",
    "sentence_len": 4
  },
  "116": {
    "sententce_ID": 116,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "do\u3000have to make",
      "word_bottom": "have to make"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "dinner"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "at",
      "word_bottom": "home"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "tonight"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I have to make dinner at home tonight.",
    "sentence_len": 5
  },
  "117": {
    "sententce_ID": 117,
    "1": {
      "word": "",
      "word_top": "Kumi",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "may\u3000know",
      "word_bottom": "may know"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "the answer"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Kumi may know the answer.",
    "sentence_len": 3
  },
  "118": {
    "sententce_ID": 118,
    "1": {
      "word": "",
      "word_top": "Children",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "should\u3000play",
      "word_bottom": "should play"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": "outside"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "every day"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Children should play outside every day.",
    "sentence_len": 4
  },
  "119": {
    "sententce_ID": 119,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "will\u3000close",
      "word_bottom": "will close"
    },
    "3": {
      "word": "",
      "word_top": "The museum",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "this Novemver"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The museum will close this November.",
    "sentence_len": 3
  },
  "120": {
    "sententce_ID": 120,
    "1": {
      "word": "",
      "word_top": "Ichiro",
      "word_bottom": "a classmete"
    },
    "2": {
      "word": "",
      "word_top": "is\u3000going to marry",
      "word_bottom": "is going to marry"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "in",
      "word_bottom": "the U.S."
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "this April"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Ichiro is going to marry a classmete in the U.S. this April.",
    "sentence_len": 4
  },
  "121": {
    "sententce_ID": 121,
    "1": {
      "word": "",
      "word_top": "Mike",
      "word_bottom": "his math teacher"
    },
    "2": {
      "word": "",
      "word_top": "does\u3000want to meet",
      "word_bottom": "wants to meet"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "with  questions",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Mike wants to meet his math teacher with questions.",
    "sentence_len": 3
  },
  "122": {
    "sententce_ID": 122,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "The important thing",
      "word_bottom": "to kick the ball"
    },
    "4": {
      "word": "",
      "word_top": " hard",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The important thing is to kick the ball hard.",
    "sentence_len": 3
  },
  "123": {
    "sententce_ID": 123,
    "1": {
      "word": "",
      "word_top": "We",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "do\u3000want to see",
      "word_bottom": "want to see"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "your performance"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "at",
      "word_bottom": "the concert"
    },
    "6": {
      "word": "",
      "word_top": " ",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "We want to see your performance at the contest.",
    "sentence_len": 5
  },
  "124": {
    "sententce_ID": 124,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "would\u3000like to use",
      "word_bottom": "would like to use"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "this copy machine"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "in",
      "word_bottom": "my office"
    },
    "6": {
      "word": "",
      "word_top": "in",
      "word_bottom": "the future"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I would like to use this copy machine in my office in my future.",
    "sentence_len": 5
  },
  "125": {
    "sententce_ID": 125,
    "1": {
      "word": "",
      "word_top": "Our teacher",
      "word_bottom": "us"
    },
    "2": {
      "word": "",
      "word_top": "would\u3000like to ask",
      "word_bottom": "would like to ask"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "a few questions"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Our teachers would like to ask us a few questions.",
    "sentence_len": 3
  },
  "126": {
    "sententce_ID": 126,
    "1": {
      "word": "",
      "word_top": "Emi",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": "here"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "to help you",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Emi is here to help you.",
    "sentence_len": 4
  },
  "127": {
    "sententce_ID": 127,
    "1": {
      "word": "",
      "word_top": "Ichiro",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "does\u3000study",
      "word_bottom": "studies"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "English"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "to travel abroad",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Ichiro studies English to travel abroad.",
    "sentence_len": 4
  },
  "128": {
    "sententce_ID": 128,
    "1": {
      "word": "",
      "word_top": "Sachiko",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "will\u3000go",
      "word_bottom": "will go"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "to",
      "word_bottom": "New York"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "to study dance",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Sachiko will go to New York to study dance.",
    "sentence_len": 4
  },
  "129": {
    "sententce_ID": 129,
    "1": {
      "word": "",
      "word_top": "My sister",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " happy",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "to hear the news",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "My sister is happy to hear the news.",
    "sentence_len": 4
  },
  "130": {
    "sententce_ID": 130,
    "1": {
      "word": "",
      "word_top": "We",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "are\u3000visiting",
      "word_bottom": "are visiting"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": "this place"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "to see guide dogs",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "We are visiting this place to see guide dogs.",
    "sentence_len": 4
  },
  "131": {
    "sententce_ID": 131,
    "1": {
      "word": "",
      "word_top": "Kumi",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "does\u3000have",
      "word_bottom": "has"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "a lot of books to read"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Kumi has a lot of books to read.",
    "sentence_len": 3
  },
  "132": {
    "sententce_ID": 132,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "do\u3000have",
      "word_bottom": "have"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "a lot of things to do"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "today"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I have a lot of things to do today.",
    "sentence_len": 4
  },
  "133": {
    "sententce_ID": 133,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "are\u3000",
      "word_bottom": "are"
    },
    "3": {
      "word": "",
      "word_top": "many kinds of food to try",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "There",
      "word_bottom": "in Japan"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "There are many kinds of food to try in Japan.",
    "sentence_len": 3
  },
  "134": {
    "sententce_ID": 134,
    "1": {
      "word": "",
      "word_top": "Miyuki",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "did\u3000buy",
      "word_bottom": "bought"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "something to eat"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "at",
      "word_bottom": "the shop"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Miyuki bought something to eat at the shop.",
    "sentence_len": 4
  },
  "135": {
    "sententce_ID": 135,
    "1": {
      "word": "",
      "word_top": "Mary",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "does\u3000have",
      "word_bottom": "has"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "various things to learn"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "in",
      "word_bottom": "Japan"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Mary has various things to learn in Japan.",
    "sentence_len": 4
  },
  "136": {
    "sententce_ID": 136,
    "1": {
      "word": "",
      "word_top": "The students",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "did\u3000finish",
      "word_bottom": "finished"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "cleaning the classroom"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The students finished cleaning the classroom.",
    "sentence_len": 3
  },
  "137": {
    "sententce_ID": 137,
    "1": {
      "word": "",
      "word_top": "Kana",
      "word_bottom": "with her friends"
    },
    "2": {
      "word": "",
      "word_top": "did\u3000enjoy",
      "word_bottom": "enjoyed"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "eating dinner"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Kana enjoyed eating dinner with her friends.",
    "sentence_len": 3
  },
  "138": {
    "sententce_ID": 138,
    "1": {
      "word": "",
      "word_top": "I ",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "will\u3000remenber to send",
      "word_bottom": "remember to send"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "an e-mail to Mike"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "later"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I will remember to send an e-mail to Mike later.",
    "sentence_len": 4
  },
  "139": {
    "sententce_ID": 139,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "do\u3000remember",
      "word_bottom": "remember"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "sending e-mail to Mike last night"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I remember sending e-mail to Mike last night.",
    "sentence_len": 3
  },
  "140": {
    "sententce_ID": 140,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "did\u3000stop",
      "word_bottom": "stopped"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "talking about the accident"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I stopped talking about the accident.",
    "sentence_len": 3
  },
  "141": {
    "sententce_ID": 141,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "are\u3000",
      "word_bottom": "are"
    },
    "3": {
      "word": "",
      "word_top": "Pandas",
      "word_bottom": "than koalas"
    },
    "4": {
      "word": "",
      "word_top": " cuter",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Pandas are cuter than koalas.",
    "sentence_len": 3
  },
  "142": {
    "sententce_ID": 142,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "The cup",
      "word_bottom": "as that one"
    },
    "4": {
      "word": "",
      "word_top": " as big",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "This cap is as big as that one.",
    "sentence_len": 3
  },
  "143": {
    "sententce_ID": 143,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "Australia",
      "word_bottom": "the largest island"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "in",
      "word_bottom": "the world"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Australia is the largest island in the world.",
    "sentence_len": 3
  },
  "144": {
    "sententce_ID": 144,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "Baseball",
      "word_bottom": "than rugby"
    },
    "4": {
      "word": "",
      "word_top": " more popular",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "in",
      "word_bottom": "Japan"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Baseball is more popular than rugby in Japan.",
    "sentence_len": 4
  },
  "145": {
    "sententce_ID": 145,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "The most important thing",
      "word_bottom": "having friends"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The most important thing is having friends.",
    "sentence_len": 2
  },
  "146": {
    "sententce_ID": 146,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "Soccer",
      "word_bottom": "of the sports"
    },
    "4": {
      "word": "",
      "word_top": " the most difficult",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Soccer is the most difficult of the sports.",
    "sentence_len": 3
  },
  "147": {
    "sententce_ID": 147,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "February",
      "word_bottom": "the shortest month of the year"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "February is the shortest month of the year.",
    "sentence_len": 2
  },
  "148": {
    "sententce_ID": 148,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "Mori JP Tower",
      "word_bottom": "as Tokyo Tower"
    },
    "4": {
      "word": "",
      "word_top": " as tall",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Mori JP Tower is as tall as Tokyo Tower.",
    "sentence_len": 3
  },
  "149": {
    "sententce_ID": 149,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "Gozilla",
      "word_bottom": "than the Statue of Liberty"
    },
    "4": {
      "word": "",
      "word_top": " taller",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Gozilla is taller than the Statue of Liberty. ",
    "sentence_len": 3
  },
  "150": {
    "sententce_ID": 150,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "This house",
      "word_bottom": "of all houses"
    },
    "4": {
      "word": "",
      "word_top": " the oldest",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "in ",
      "word_bottom": "this area"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "This house is the oldest of all houses in this area.",
    "sentence_len": 4
  },
  "151": {
    "sententce_ID": 151,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "The gray vase",
      "word_bottom": "than the white vase"
    },
    "4": {
      "word": "",
      "word_top": " more expensive",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The gray vase is more expencive than the white vase.",
    "sentence_len": 3
  },
  "152": {
    "sententce_ID": 152,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "'My neighbor Totoro'",
      "word_bottom": "than 'Your Name'"
    },
    "4": {
      "word": "",
      "word_top": " older",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "'My Neighbor Totoro' is older than 'Your Name'. ",
    "sentence_len": 3
  },
  "153": {
    "sententce_ID": 153,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "This picture",
      "word_bottom": "than that picture"
    },
    "4": {
      "word": "",
      "word_top": " more beautiful",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "This picture is more beautiful than that picture.",
    "sentence_len": 3
  },
  "154": {
    "sententce_ID": 154,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "This store",
      "word_bottom": "as that store"
    },
    "4": {
      "word": "",
      "word_top": " as popular",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "This store is as popular as that store.",
    "sentence_len": 3
  },
  "155": {
    "sententce_ID": 155,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "The Everest",
      "word_bottom": "than any montain"
    },
    "4": {
      "word": "",
      "word_top": " higher",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "in",
      "word_bottom": "the world"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Mt. Everest is higher than any montain in the world.",
    "sentence_len": 4
  },
  "156": {
    "sententce_ID": 156,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is \u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "Russia",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " the largest",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "in",
      "word_bottom": "the world"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Russia is the largest in the world.",
    "sentence_len": 4
  },
  "157": {
    "sententce_ID": 157,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "Mr.Fuji",
      "word_bottom": "as Mt.Cook"
    },
    "4": {
      "word": "",
      "word_top": " as high",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Mt. Fuji is as high as Mt. Cook.",
    "sentence_len": 3
  },
  "158": {
    "sententce_ID": 158,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "The USA",
      "word_bottom": "one of the most popular place to visit"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "in",
      "word_bottom": "Osaka"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The USJ is one of the most popular place to visit in Osaka.",
    "sentence_len": 3
  },
  "159": {
    "sententce_ID": 159,
    "1": {
      "word": "",
      "word_top": "Kumi",
      "word_bottom": "as Emily"
    },
    "2": {
      "word": "",
      "word_top": "can\u3000swim",
      "word_bottom": "can swim"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " as fast",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Kumi can swim as fast as Emily.",
    "sentence_len": 3
  },
  "160": {
    "sententce_ID": 160,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "Lake Biwa",
      "word_bottom": "the largest lake"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "in",
      "word_bottom": "Japan"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Lake Biwa is the largest lake in Japan.",
    "sentence_len": 3
  },
  "161": {
    "sententce_ID": 161,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "does\u3000taste",
      "word_bottom": "tastes"
    },
    "3": {
      "word": "",
      "word_top": "This chololate",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " good",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "This chocolate tastes good.",
    "sentence_len": 3
  },
  "162": {
    "sententce_ID": 162,
    "1": {
      "word": "",
      "word_top": "Kumi",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "will\u3000become",
      "word_bottom": "will become"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "a good scientist"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Kumi will become a good scientist.",
    "sentence_len": 3
  },
  "163": {
    "sententce_ID": 163,
    "1": {
      "word": "",
      "word_top": "Taro",
      "word_bottom": "Hanako"
    },
    "2": {
      "word": "",
      "word_top": "did\u3000show",
      "word_bottom": "showed"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "this picture"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Taro showed Hanako this picture.",
    "sentence_len": 3
  },
  "164": {
    "sententce_ID": 164,
    "1": {
      "word": "",
      "word_top": "Mr. Yamaguchi",
      "word_bottom": "people"
    },
    "2": {
      "word": "",
      "word_top": "does\u3000always make",
      "word_bottom": "always makes"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " happy",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Mr. Yamaguchi always makes people happy.",
    "sentence_len": 3
  },
  "165": {
    "sententce_ID": 165,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "are\u3000",
      "word_bottom": "are"
    },
    "3": {
      "word": "",
      "word_top": "The houses in the village",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " beautiful",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The houses in this village are beautiful.",
    "sentence_len": 3
  },
  "166": {
    "sententce_ID": 166,
    "1": {
      "word": "",
      "word_top": "Ken",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "did\u3000look",
      "word_bottom": "looked"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " tired",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "yesterday"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Ken looked tired yesterday.",
    "sentence_len": 4
  },
  "167": {
    "sententce_ID": 167,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "My dream",
      "word_bottom": "to become a doctor"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "My dream is to be a doctor.",
    "sentence_len": 2
  },
  "168": {
    "sententce_ID": 168,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": "people"
    },
    "2": {
      "word": "",
      "word_top": "do\u3000give",
      "word_bottom": "give"
    },
    "3": {
      "word": "",
      "word_top": "Bees",
      "word_bottom": "honey"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Bees give people honey.",
    "sentence_len": 3
  },
  "169": {
    "sententce_ID": 169,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": "people"
    },
    "2": {
      "word": "",
      "word_top": "does\u3000make",
      "word_bottom": "makes"
    },
    "3": {
      "word": "",
      "word_top": "Honey",
      "word_bottom": "healthy"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Honey makes people healthy.",
    "sentence_len": 3
  },
  "170": {
    "sententce_ID": 170,
    "1": {
      "word": "",
      "word_top": "My friends",
      "word_bottom": "me"
    },
    "2": {
      "word": "",
      "word_top": "do\u3000call",
      "word_bottom": "call"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "Kenchan"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "My friends call me Kenchan.",
    "sentence_len": 3
  },
  "171": {
    "sententce_ID": 171,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "does\u3000smell",
      "word_bottom": "smells"
    },
    "3": {
      "word": "",
      "word_top": "This flower",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " so nice",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "This flower smells so nice.",
    "sentence_len": 3
  },
  "172": {
    "sententce_ID": 172,
    "1": {
      "word": "",
      "word_top": "My mother",
      "word_bottom": "me"
    },
    "2": {
      "word": "",
      "word_top": "does\u3000tell",
      "word_bottom": "tells"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "a story"
    },
    "4": {
      "word": "",
      "word_top": "  ",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "in",
      "word_bottom": "bed"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "every night"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "My mother tells me a story in bed every night.",
    "sentence_len": 6
  },
  "173": {
    "sententce_ID": 173,
    "1": {
      "word": "",
      "word_top": "Ken's father",
      "word_bottom": "Ken"
    },
    "2": {
      "word": "",
      "word_top": "did\u3000give",
      "word_bottom": "gave"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "a book"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Ken's father gave Ken a book.",
    "sentence_len": 3
  },
  "174": {
    "sententce_ID": 174,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": "me"
    },
    "2": {
      "word": "",
      "word_top": "did\u3000make",
      "word_bottom": "made"
    },
    "3": {
      "word": "",
      "word_top": "This news",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " sad",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "yesterday"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "This news made me sad yesterday.",
    "sentence_len": 5
  },
  "175": {
    "sententce_ID": 175,
    "1": {
      "word": "",
      "word_top": "We",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "do\u3000call",
      "word_bottom": "call"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "our dog=Pochi"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "We call our dog Pochi.",
    "sentence_len": 3
  },
  "176": {
    "sententce_ID": 176,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "does\u3000sound",
      "word_bottom": "sounds"
    },
    "3": {
      "word": "",
      "word_top": "This song",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " very cool",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "This song sounds very cool.",
    "sentence_len": 3
  },
  "177": {
    "sententce_ID": 177,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "My favorite food",
      "word_bottom": "okonomiyaki"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "My favorite food is okonomiyaki.",
    "sentence_len": 2
  },
  "178": {
    "sententce_ID": 178,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": "people"
    },
    "2": {
      "word": "",
      "word_top": "are\u3000making",
      "word_bottom": "are making"
    },
    "3": {
      "word": "",
      "word_top": "Kenshi's songs",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " excited",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Kenshi's songs are making people excited.",
    "sentence_len": 4
  },
  "179": {
    "sententce_ID": 179,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": "my daughter"
    },
    "2": {
      "word": "",
      "word_top": "will\u3000give",
      "word_bottom": "will give"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "a wallet"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "on",
      "word_bottom": "her birthday"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I will give my daughter a wallet on her birthday.",
    "sentence_len": 4
  },
  "180": {
    "sententce_ID": 180,
    "1": {
      "word": "",
      "word_top": "They",
      "word_bottom": "their son"
    },
    "2": {
      "word": "",
      "word_top": "did\u3000name",
      "word_bottom": "named"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "Shohei"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "They named their son Shohei.",
    "sentence_len": 3
  },
  "181": {
    "sententce_ID": 181,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": "you"
    },
    "2": {
      "word": "",
      "word_top": "do\u3000want",
      "word_bottom": "want"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "to play the piano"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I want you to play the piano.",
    "sentence_len": 3
  },
  "182": {
    "sententce_ID": 182,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": "for me"
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "It=to practice judo ",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " important",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "It is important for me to practice judo.",
    "sentence_len": 4
  },
  "183": {
    "sententce_ID": 183,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "do\u3000feel",
      "word_bottom": "feel"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "that June is the best season of the year."
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I feel that June is the best month of the year.",
    "sentence_len": 3
  },
  "184": {
    "sententce_ID": 184,
    "1": {
      "word": "",
      "word_top": "Kumi",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "does\u3000know",
      "word_bottom": "knows"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "how to make a lot of friends"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Kumi knows how to make a lot of friends. ",
    "sentence_len": 3
  },
  "185": {
    "sententce_ID": 185,
    "1": {
      "word": "",
      "word_top": "Tom",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "does\u3000know",
      "word_bottom": "knows"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "why Miki was absent from school"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Tom knows why Miyuki was absent from school.",
    "sentence_len": 3
  },
  "186": {
    "sententce_ID": 186,
    "1": {
      "word": "",
      "word_top": "My mother",
      "word_bottom": "me"
    },
    "2": {
      "word": "",
      "word_top": "did\u3000ask",
      "word_bottom": "asked"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "to open the window"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "My mother asked me to open the window.",
    "sentence_len": 3
  },
  "187": {
    "sententce_ID": 187,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": "for me"
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "It=to take pictures ",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " fun",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "It is fun for me to take pictures.",
    "sentence_len": 4
  },
  "188": {
    "sententce_ID": 188,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "did\u3000hear",
      "word_bottom": "heard"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "that curry came to Japan from India"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I heard that curry came to Japan from India.",
    "sentence_len": 3
  },
  "189": {
    "sententce_ID": 189,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "do\u3000know",
      "word_bottom": "know"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "what to do next"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I know what to do next.",
    "sentence_len": 3
  },
  "190": {
    "sententce_ID": 190,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "does\u3000show",
      "word_bottom": "shows"
    },
    "3": {
      "word": "",
      "word_top": "This sign",
      "word_bottom": "wnere bears may appear"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "This sign shows where bears may appear.",
    "sentence_len": 2
  },
  "191": {
    "sententce_ID": 191,
    "1": {
      "word": "",
      "word_top": "My mother",
      "word_bottom": "me"
    },
    "2": {
      "word": "",
      "word_top": "did\u3000tell",
      "word_bottom": "told"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "to clean my room"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "My mother told me to clean my room.",
    "sentence_len": 3
  },
  "192": {
    "sententce_ID": 192,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": "for me"
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "It=to get up early",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " easy",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "It is easy for me to get up early.",
    "sentence_len": 4
  },
  "193": {
    "sententce_ID": 193,
    "1": {
      "word": "",
      "word_top": "Ken's mother",
      "word_bottom": "me"
    },
    "2": {
      "word": "",
      "word_top": "did\u3000tell",
      "word_bottom": "told"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "that Kumi was in the hospital"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Kumi's mother told me that Kumi was in the hospital.",
    "sentence_len": 3
  },
  "194": {
    "sententce_ID": 194,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": "you"
    },
    "2": {
      "word": "",
      "word_top": "can\u3000show",
      "word_bottom": "can show"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "how to use this electoronic dictionary"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I can show you how to use this electoronic dictionary.",
    "sentence_len": 3
  },
  "195": {
    "sententce_ID": 195,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "do\u3000know",
      "word_bottom": "know"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "when your birthday is"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I know when your birthday is.",
    "sentence_len": 3
  },
  "196": {
    "sententce_ID": 196,
    "1": {
      "word": "",
      "word_top": "Our teacher",
      "word_bottom": "us"
    },
    "2": {
      "word": "",
      "word_top": "does\u3000always want",
      "word_bottom": "always wants"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "to make our classroom clean"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Our teacher always wants us to make our classroom clean. ",
    "sentence_len": 3
  },
  "197": {
    "sententce_ID": 197,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": "for us"
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "It=to use AI effectively",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " useful",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "It is useful for us to use AI effectively.",
    "sentence_len": 4
  },
  "198": {
    "sententce_ID": 198,
    "1": {
      "word": "",
      "word_top": "My mother",
      "word_bottom": "me"
    },
    "2": {
      "word": "",
      "word_top": "did\u3000teach",
      "word_bottom": "taught"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "that getting up early is important"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "My mother taught me that getting up early is important.",
    "sentence_len": 3
  },
  "199": {
    "sententce_ID": 199,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "am\u3000",
      "word_bottom": "am"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "that it will rain tomorrow"
    },
    "4": {
      "word": "",
      "word_top": " afraid",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I'm afraid that it will rain tomorrow.",
    "sentence_len": 4
  },
  "200": {
    "sententce_ID": 200,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "do\u3000know",
      "word_bottom": "know"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "who wrote this story"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I know who wrote this story.",
    "sentence_len": 3
  },
  "201": {
    "sententce_ID": 201,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000made",
      "word_bottom": "is made"
    },
    "3": {
      "word": "",
      "word_top": "This chololate",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "in",
      "word_bottom": "Hokkaido"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "This chololate is made in Hokkaido.",
    "sentence_len": 3
  },
  "202": {
    "sententce_ID": 202,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": "by American people"
    },
    "2": {
      "word": "",
      "word_top": "is\u3000called",
      "word_bottom": "is called"
    },
    "3": {
      "word": "",
      "word_top": "This dog",
      "word_bottom": "Decoy"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "This dog is called Decoy by American people.",
    "sentence_len": 3
  },
  "203": {
    "sententce_ID": 203,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "are\u3000translated",
      "word_bottom": "are translated"
    },
    "3": {
      "word": "",
      "word_top": "Soseki's books",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "around",
      "word_bottom": "the world"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Soseki's books are translated around the world.",
    "sentence_len": 3
  },
  "204": {
    "sententce_ID": 204,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": "by Natsume Soseki"
    },
    "2": {
      "word": "",
      "word_top": "was\u3000written",
      "word_bottom": "was written"
    },
    "3": {
      "word": "",
      "word_top": "Botchan",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "in",
      "word_bottom": 1906
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Botchan was written by Natsume Soseki in 1906.",
    "sentence_len": 4
  },
  "205": {
    "sententce_ID": 205,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "should\u3000be spent",
      "word_bottom": "should be spent"
    },
    "3": {
      "word": "",
      "word_top": "Money",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " wisely",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Money should be spent wisely.",
    "sentence_len": 3
  },
  "206": {
    "sententce_ID": 206,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": "to people"
    },
    "2": {
      "word": "",
      "word_top": "is\u3000known",
      "word_bottom": "is known"
    },
    "3": {
      "word": "",
      "word_top": "Kinkakuji Temple",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "around",
      "word_bottom": "the world"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Kinkakuji Temple is known to people around the world.",
    "sentence_len": 4
  },
  "207": {
    "sententce_ID": 207,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": "by a lot of people"
    },
    "2": {
      "word": "",
      "word_top": "are\u3000spoken",
      "word_bottom": "are spoken"
    },
    "3": {
      "word": "",
      "word_top": "English and Spanish",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "in",
      "word_bottom": "the world"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "English and Spanish are spoken by a lot of people in the world.",
    "sentence_len": 4
  },
  "208": {
    "sententce_ID": 208,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": "by Ms. Sato"
    },
    "2": {
      "word": "",
      "word_top": "was\u3000sent",
      "word_bottom": "was sent"
    },
    "3": {
      "word": "",
      "word_top": "This letter",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "to",
      "word_bottom": "the office"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "This letter was sent to the office by Ms. Sato.",
    "sentence_len": 4
  },
  "209": {
    "sententce_ID": 209,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "was\u3000taken",
      "word_bottom": "was taken"
    },
    "3": {
      "word": "",
      "word_top": "The picture",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "in",
      "word_bottom": "Osaka"
    },
    "6": {
      "word": "",
      "word_top": "last",
      "word_bottom": "month"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "This picture was taken in Osaka last month.",
    "sentence_len": 4
  },
  "210": {
    "sententce_ID": 210,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "can\u3000be seen",
      "word_bottom": "can be seen"
    },
    "3": {
      "word": "",
      "word_top": "Mr.Fuji",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "from",
      "word_bottom": "different angles"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Mt. Fuji can be seen from different angles.",
    "sentence_len": 3
  },
  "211": {
    "sententce_ID": 211,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000selected",
      "word_bottom": "is selected"
    },
    "3": {
      "word": "",
      "word_top": "Mt.Fuji",
      "word_bottom": "as a World Heritage site"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Mt.Fuji is selected as a World Heritage site.",
    "sentence_len": 2
  },
  "212": {
    "sententce_ID": 212,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": "by local people"
    },
    "2": {
      "word": "",
      "word_top": "is \u3000loved",
      "word_bottom": "is loved"
    },
    "3": {
      "word": "",
      "word_top": "The restautant",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The rentaurant is loved by local people.",
    "sentence_len": 3
  },
  "213": {
    "sententce_ID": 213,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "are\u3000covered",
      "word_bottom": "are covered"
    },
    "3": {
      "word": "",
      "word_top": "The houses",
      "word_bottom": "with snow"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "yesterday"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The houses were covered with snow yesterday.",
    "sentence_len": 3
  },
  "214": {
    "sententce_ID": 214,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": "by Picasso"
    },
    "2": {
      "word": "",
      "word_top": "was\u3000painted",
      "word_bottom": "was painted"
    },
    "3": {
      "word": "",
      "word_top": "This picture",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "in",
      "word_bottom": 1937
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "This picture was painted by Picasso in 1937.",
    "sentence_len": 4
  },
  "215": {
    "sententce_ID": 215,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "can\u3000be seen",
      "word_bottom": "can be seen"
    },
    "3": {
      "word": "",
      "word_top": "Many ruins of ancient Greek",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": "here"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Many ruins of ancient Greek can be seen here.",
    "sentence_len": 3
  },
  "216": {
    "sententce_ID": 216,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": "by many tourists"
    },
    "2": {
      "word": "",
      "word_top": "is\u3000visited",
      "word_bottom": "is visited"
    },
    "3": {
      "word": "",
      "word_top": "Kyoto",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "in",
      "word_bottom": "spring and fall"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Kyoto is visited by many tourists in spring and fall.",
    "sentence_len": 4
  },
  "217": {
    "sententce_ID": 217,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": "by her sister"
    },
    "2": {
      "word": "",
      "word_top": "is\u3000cleaned",
      "word_bottom": "is cleaned"
    },
    "3": {
      "word": "",
      "word_top": "This kitchen",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "every day"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "This kitchen is cleaned by her sister every day.",
    "sentence_len": 4
  },
  "218": {
    "sententce_ID": 218,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": "by millions of people"
    },
    "2": {
      "word": "",
      "word_top": "are\u3000sung",
      "word_bottom": "are sung"
    },
    "3": {
      "word": "",
      "word_top": "Her songs",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "around",
      "word_bottom": "the world"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Her songs are sung by millions of people aroud the world.",
    "sentence_len": 4
  },
  "219": {
    "sententce_ID": 219,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": "by Ashikaga Yoshitsu"
    },
    "2": {
      "word": "",
      "word_top": "was\u3000built",
      "word_bottom": "was built"
    },
    "3": {
      "word": "",
      "word_top": "Kinkakuji Temple",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "in",
      "word_bottom": 1397
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Kinkakuji Temple was built by Ashikaga Yoshimitsu in 1397.",
    "sentence_len": 4
  },
  "220": {
    "sententce_ID": 220,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "will\u3000be held",
      "word_bottom": "will be held"
    },
    "3": {
      "word": "",
      "word_top": "Peace Concert",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "in",
      "word_bottom": "this town"
    },
    "6": {
      "word": "",
      "word_top": "this",
      "word_bottom": "weekend"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Peace Concert will be held in this town this weekend.",
    "sentence_len": 4
  },
  "221": {
    "sententce_ID": 221,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "have\u3000already read",
      "word_bottom": "have already read"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "the book"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I have already read the book.",
    "sentence_len": 3
  },
  "222": {
    "sententce_ID": 222,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "have\u3000been practicing",
      "word_bottom": "have been practicing"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "judo"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "since",
      "word_bottom": "I was eight years old"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I have been practicing judo since I was eight years old.",
    "sentence_len": 4
  },
  "223": {
    "sententce_ID": 223,
    "1": {
      "word": "",
      "word_top": "Ken",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "has\u3000lived",
      "word_bottom": "has lived"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "for twelve years",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "in",
      "word_bottom": "this town"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Ken has lived in this town for twelve years.",
    "sentence_len": 4
  },
  "224": {
    "sententce_ID": 224,
    "1": {
      "word": "",
      "word_top": "Satoru",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "has\u3000been",
      "word_bottom": "has been"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " twice",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "to",
      "word_bottom": "Singapore"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Satoru has been to Singapore twice.",
    "sentence_len": 4
  },
  "225": {
    "sententce_ID": 225,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "have\u3000been playing",
      "word_bottom": "have been playing"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "the game"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "since ",
      "word_bottom": "this morning"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I have been playing the game since this morning.",
    "sentence_len": 4
  },
  "226": {
    "sententce_ID": 226,
    "1": {
      "word": "",
      "word_top": "Hiroko",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "has\u3000just started",
      "word_bottom": "has  just started"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "reading the story"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "at",
      "word_bottom": "the library"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Hiroko has just started reading the story at the library.",
    "sentence_len": 4
  },
  "227": {
    "sententce_ID": 227,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": "with Kana"
    },
    "2": {
      "word": "",
      "word_top": "have\u3000lived",
      "word_bottom": "have lived"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "for seven years",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I have lived with Kana for seven years.",
    "sentence_len": 3
  },
  "228": {
    "sententce_ID": 228,
    "1": {
      "word": "",
      "word_top": "Kumi",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "has\u3000been",
      "word_bottom": "has been"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " busy",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "since",
      "word_bottom": "last month"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Kumi has been busy since last month.",
    "sentence_len": 4
  },
  "229": {
    "sententce_ID": 229,
    "1": {
      "word": "",
      "word_top": "Taro",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "has\u3000visited",
      "word_bottom": "has visited"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " four times",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": "Okinawa"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Taro has visited Okinawa four times.",
    "sentence_len": 4
  },
  "230": {
    "sententce_ID": 230,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "has\u3000been raining",
      "word_bottom": "has been raining"
    },
    "3": {
      "word": "",
      "word_top": "It",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "since",
      "word_bottom": "last night"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "It has been raining since last night.",
    "sentence_len": 3
  },
  "231": {
    "sententce_ID": 231,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "have\u3000already packed",
      "word_bottom": "have already packed"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "the bags"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "for the trip",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I have already packed the bags for the trip.",
    "sentence_len": 4
  },
  "232": {
    "sententce_ID": 232,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "have\u3000lived",
      "word_bottom": "have lived"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "for  three years",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "in",
      "word_bottom": "America"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I have lived in Amarica for three years.",
    "sentence_len": 4
  },
  "233": {
    "sententce_ID": 233,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "has\u3000been",
      "word_bottom": "has been"
    },
    "3": {
      "word": "",
      "word_top": "It ",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " snowy",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "since",
      "word_bottom": "last night"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "It has been snowy since last night.",
    "sentence_len": 4
  },
  "234": {
    "sententce_ID": 234,
    "1": {
      "word": "",
      "word_top": "Mr. Smith",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "has\u3000eaten",
      "word_bottom": "has eaten"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "sukiyaki"
    },
    "4": {
      "word": "",
      "word_top": " once",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Mr. Smith has eaten sukiyaki once.",
    "sentence_len": 4
  },
  "235": {
    "sententce_ID": 235,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "have\u3000been reading",
      "word_bottom": "have been reading"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "the book"
    },
    "4": {
      "word": "",
      "word_top": "for three hours",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I have been reading the book for three hours.",
    "sentence_len": 4
  },
  "236": {
    "sententce_ID": 236,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "have\u3000just finished",
      "word_bottom": "have just finished"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "my homework"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I have just finished my homework.",
    "sentence_len": 3
  },
  "237": {
    "sententce_ID": 237,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "have\u3000lived",
      "word_bottom": "have lived"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "for twenty years",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "in",
      "word_bottom": "Nanano"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I have lived in Nagano for twenty years.",
    "sentence_len": 4
  },
  "238": {
    "sententce_ID": 238,
    "1": {
      "word": "",
      "word_top": "Ken",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "has\u3000been",
      "word_bottom": "has been"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " sick",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "in",
      "word_bottom": "bed"
    },
    "6": {
      "word": "",
      "word_top": "since",
      "word_bottom": "last Tuesday"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Ken has been sick in bed since last Tuesday.",
    "sentence_len": 5
  },
  "239": {
    "sententce_ID": 239,
    "1": {
      "word": "",
      "word_top": "Mike",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "has\u3000seen",
      "word_bottom": "has seen"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "wheelchair tennis"
    },
    "4": {
      "word": "",
      "word_top": " five times",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Mike has seen wheelchair tennis five times.",
    "sentence_len": 4
  },
  "240": {
    "sententce_ID": 240,
    "1": {
      "word": "",
      "word_top": "The students",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "have\u3000been walking",
      "word_bottom": "have been walking"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "for one hour",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "on",
      "word_bottom": "the road"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The students have been walking on the road for one hour.",
    "sentence_len": 4
  },
  "241": {
    "sententce_ID": 241,
    "1": {
      "word": "",
      "word_top": "Kenta",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "did\u3000look at",
      "word_bottom": "looked at"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "the sleeping dog"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Ken looked at the sleeping dog.",
    "sentence_len": 3
  },
  "242": {
    "sententce_ID": 242,
    "1": {
      "word": "",
      "word_top": "The woman singing on the stage",
      "word_bottom": "Ms.Watanabe"
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The woman singing on the stage is Ms. Watanabe. ",
    "sentence_len": 2
  },
  "243": {
    "sententce_ID": 243,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "The picture painted by Picasso",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " very expensive",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The picture painted by Picasso is very expensive.",
    "sentence_len": 3
  },
  "244": {
    "sententce_ID": 244,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": "the studen playing the piano on the stage"
    },
    "2": {
      "word": "",
      "word_top": "do\u3000know",
      "word_bottom": "know"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I know the student playing the guitar on the stage.",
    "sentence_len": 2
  },
  "245": {
    "sententce_ID": 245,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "This",
      "word_bottom": "a famous watch made in Switzerland"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "This is a famous watch made in Switzerland.",
    "sentence_len": 2
  },
  "246": {
    "sententce_ID": 246,
    "1": {
      "word": "",
      "word_top": "Mr.Tanaka",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "did\u3000repair",
      "word_bottom": "repaired"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "the broken window"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Mr.Tanaka repaired the broken window.",
    "sentence_len": 3
  },
  "247": {
    "sententce_ID": 247,
    "1": {
      "word": "",
      "word_top": "The girl wearing a red ribbon",
      "word_bottom": "Kumiko"
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The girl wearing a red ribbon is Kumiko.",
    "sentence_len": 2
  },
  "248": {
    "sententce_ID": 248,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "are\u3000",
      "word_bottom": "are"
    },
    "3": {
      "word": "",
      "word_top": "The books witten by Soseki",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " very interesting",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The books written by Soseki are very interesting.",
    "sentence_len": 3
  },
  "249": {
    "sententce_ID": 249,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "do\u3000like",
      "word_bottom": "like"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "the mascot wearing a red hat"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I like the mascot wearing a red hat.",
    "sentence_len": 3
  },
  "250": {
    "sententce_ID": 250,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "This ",
      "word_bottom": "a popular song sung amang young people"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "This is a polular song sung among young people.",
    "sentence_len": 2
  },
  "251": {
    "sententce_ID": 251,
    "1": {
      "word": "",
      "word_top": "A firefighter",
      "word_bottom": "an old woman"
    },
    "2": {
      "word": "",
      "word_top": "did\u3000save",
      "word_bottom": "saved"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "from",
      "word_bottom": "a burning house"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "A firefighter saved an old woman from a burning house.",
    "sentence_len": 3
  },
  "252": {
    "sententce_ID": 252,
    "1": {
      "word": "",
      "word_top": "The girl playing basketball",
      "word_bottom": "Maki"
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The girl playing basketball is Maki.",
    "sentence_len": 2
  },
  "253": {
    "sententce_ID": 253,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "The building built in my town",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " great",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The building built in my town is great.",
    "sentence_len": 3
  },
  "254": {
    "sententce_ID": 254,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": "the cat sleeping on the bench"
    },
    "2": {
      "word": "",
      "word_top": "do\u3000like",
      "word_bottom": "like"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I like the cat sleeping on the bench.",
    "sentence_len": 2
  },
  "255": {
    "sententce_ID": 255,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "Tempura",
      "word_bottom": "a popular food loved by foreign people"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Tempura is a popular food loved by foreign people.",
    "sentence_len": 2
  },
  "256": {
    "sententce_ID": 256,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "was\u3000found",
      "word_bottom": "was found"
    },
    "3": {
      "word": "",
      "word_top": "Tom's lost suitcase",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "at",
      "word_bottom": "Kansai Airport"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": "yesterday"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Tom's lost suitcase was found at Kansai Airport yesterday.",
    "sentence_len": 4
  },
  "257": {
    "sententce_ID": 257,
    "1": {
      "word": "",
      "word_top": "The old man reading a book on the bench",
      "word_bottom": "my grandfather"
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The old man reading a book on the bench is my grandfather.",
    "sentence_len": 2
  },
  "258": {
    "sententce_ID": 258,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "does\u3000smell",
      "word_bottom": "smells"
    },
    "3": {
      "word": "",
      "word_top": "The food cooked by the famous cook",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " sweet",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The food cooked by the famous cook smells sweet.",
    "sentence_len": 3
  },
  "259": {
    "sententce_ID": 259,
    "1": {
      "word": "",
      "word_top": "The police man",
      "word_bottom": "the man walking on the street"
    },
    "2": {
      "word": "",
      "word_top": "did\u3000watch",
      "word_bottom": "watched"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The police man watched the man walking on the street.",
    "sentence_len": 2
  },
  "260": {
    "sententce_ID": 260,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "do\u3000like",
      "word_bottom": "like"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "the dress made in Italy"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I like the dress made in Italy.",
    "sentence_len": 3
  },
  "261": {
    "sententce_ID": 261,
    "1": {
      "word": "",
      "word_top": "Anne",
      "word_bottom": "a German girl who wrote a famous diary"
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Anne is a German girl who wrote a famous diary.",
    "sentence_len": 2
  },
  "262": {
    "sententce_ID": 262,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "do\u3000have",
      "word_bottom": "have"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "a cat which has blue eyes"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I have a cat which has blue eyes.",
    "sentence_len": 3
  },
  "263": {
    "sententce_ID": 263,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "was\u3000",
      "word_bottom": "was"
    },
    "3": {
      "word": "",
      "word_top": "The book which I bought yesterday",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " difficult",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The book which I bought yesterday was difficult.",
    "sentence_len": 3
  },
  "264": {
    "sententce_ID": 264,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "The dog that is sleeping under that tree",
      "word_bottom": "Ken's"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The dog that is sleeping under that tree is Ken's.",
    "sentence_len": 2
  },
  "265": {
    "sententce_ID": 265,
    "1": {
      "word": "",
      "word_top": "Jim",
      "word_bottom": "a friend I met in the U.S"
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Jim is a math teacher (whom) I met in the U.S.",
    "sentence_len": 2
  },
  "266": {
    "sententce_ID": 266,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": "a friend who can speak French very well"
    },
    "2": {
      "word": "",
      "word_top": "do\u3000have",
      "word_bottom": "have"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I have a friend who can speak French very well.",
    "sentence_len": 2
  },
  "267": {
    "sententce_ID": 267,
    "1": {
      "word": "",
      "word_top": "Ken",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "does\u3000have",
      "word_bottom": "has"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "a magazine which has many photos"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Ken has a magazine which has many photos.",
    "sentence_len": 3
  },
  "268": {
    "sententce_ID": 268,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "Beef stew",
      "word_bottom": "the food that I like the best"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Beef stew is the food that I like the best.",
    "sentence_len": 2
  },
  "269": {
    "sententce_ID": 269,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "does\u3000have",
      "word_bottom": "has"
    },
    "3": {
      "word": "",
      "word_top": "The bag that he is carrying",
      "word_bottom": "some big pockets"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The bag that he is carrying has some big pockets.",
    "sentence_len": 2
  },
  "270": {
    "sententce_ID": 270,
    "1": {
      "word": "",
      "word_top": "Ken",
      "word_bottom": "me"
    },
    "2": {
      "word": "",
      "word_top": "did\u3000show",
      "word_bottom": "showed"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "the camera that his father gave him"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Ken showed me the camera that his father gave him.",
    "sentence_len": 3
  },
  "271": {
    "sententce_ID": 271,
    "1": {
      "word": "",
      "word_top": "Hany Yuzuru",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "was\u3000",
      "word_bottom": "was"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "an athlete who won gold medals"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Hanyu Yuzuru was an athlete who won gold medals.",
    "sentence_len": 3
  },
  "272": {
    "sententce_ID": 272,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "This",
      "word_bottom": "a movie which makes people happy"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "This is an anime movie which makes people happy.",
    "sentence_len": 2
  },
  "273": {
    "sententce_ID": 273,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "was\u3000",
      "word_bottom": "was"
    },
    "3": {
      "word": "",
      "word_top": "The cake which we ate last night",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " very delicious",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The cake which we ate last night was very delicious.",
    "sentence_len": 3
  },
  "274": {
    "sententce_ID": 274,
    "1": {
      "word": "",
      "word_top": "The old man that I helped yesterday",
      "word_bottom": "Mike's grandfather"
    },
    "2": {
      "word": "",
      "word_top": "was\u3000",
      "word_bottom": "was"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The old man that I helped yesterday was Mike's grandfather.",
    "sentence_len": 2
  },
  "275": {
    "sententce_ID": 275,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "The country that I want to visit",
      "word_bottom": "Germany"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The country that I want to visit is Germany.",
    "sentence_len": 2
  },
  "276": {
    "sententce_ID": 276,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": "a girl who does boxing"
    },
    "2": {
      "word": "",
      "word_top": "do\u3000know",
      "word_bottom": "know"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I know a girl who does boxing.",
    "sentence_len": 2
  },
  "277": {
    "sententce_ID": 277,
    "1": {
      "word": "",
      "word_top": "Steve",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "did\u3000create",
      "word_bottom": "created"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "many products which changed the world"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Steve created many products which changed the world.",
    "sentence_len": 3
  },
  "278": {
    "sententce_ID": 278,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "This ",
      "word_bottom": "the book which I read last night"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "This is the book which I read last night.",
    "sentence_len": 2
  },
  "279": {
    "sententce_ID": 279,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "This",
      "word_bottom": "the best book that I have ever read"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "This is the best book that I have ever read.",
    "sentence_len": 2
  },
  "280": {
    "sententce_ID": 280,
    "1": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "is\u3000",
      "word_bottom": "is"
    },
    "3": {
      "word": "",
      "word_top": "The gym",
      "word_bottom": "the place that I like the best in my school"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "The gym is the place that I like the best in my school.",
    "sentence_len": 2
  },
  "281": {
    "sententce_ID": 281,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "do\u3000think",
      "word_bottom": "think"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "that fire drills are important"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I think that fire drills are important.",
    "sentence_len": 3
  },
  "282": {
    "sententce_ID": 282,
    "1": {
      "word": "",
      "word_top": "My sister",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "was\u3000reading",
      "word_bottom": "was reading"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "a comic book"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "when",
      "word_bottom": "I got home"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "My sister was reading a comic book when I got home.",
    "sentence_len": 4
  },
  "283": {
    "sententce_ID": 283,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "do\u3000like",
      "word_bottom": "like"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "soccer"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "because it is very exciting",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I like soccer because it is very exciting.",
    "sentence_len": 4
  },
  "284": {
    "sententce_ID": 284,
    "1": {
      "word": "",
      "word_top": "you",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "can\u3000eat",
      "word_bottom": "can eat"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "fresh fish"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "If you go to Setouchi,",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "If you go to Setouchi, you can eat fresh fish.",
    "sentence_len": 4
  },
  "285": {
    "sententce_ID": 285,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "do\u3000wish",
      "word_bottom": "wish"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "I could speak French"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I wish I could speak French.",
    "sentence_len": 3
  },
  "286": {
    "sententce_ID": 286,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "do\u3000hope",
      "word_bottom": "hope"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "that it will be sunny tomorrow"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I hope that it will be sunny tomorrow.",
    "sentence_len": 3
  },
  "287": {
    "sententce_ID": 287,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "do\u3000see",
      "word_bottom": "see"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "many interesting dishes"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "when",
      "word_bottom": "I watch TV"
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I see many interesting dishes when I watch TV.",
    "sentence_len": 4
  },
  "288": {
    "sententce_ID": 288,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "do\u3000like",
      "word_bottom": "like"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "takoyaki"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "because it tastes good",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I like takoyaki because it tastes good.",
    "sentence_len": 4
  },
  "289": {
    "sententce_ID": 289,
    "1": {
      "word": "",
      "word_top": "we",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "will\u3000play",
      "word_bottom": "will play"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "soccer"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "If it is sunny tomorrow,",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "If it is sunny tomorrow, we will play soccer.",
    "sentence_len": 4
  },
  "290": {
    "sententce_ID": 290,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "would\u3000feel",
      "word_bottom": ""
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": " better",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "If I had some snacks,",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "If I had some snacks, I would feel better.",
    "sentence_len": 4
  },
  "291": {
    "sententce_ID": 291,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "do\u3000think",
      "word_bottom": "think"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "that there are a lot of restaurants in this town"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I think that there are a lot of good restaurants in this town.",
    "sentence_len": 3
  },
  "292": {
    "sententce_ID": 292,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "am\u3000",
      "word_bottom": "am"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "that these ideas help many people"
    },
    "4": {
      "word": "",
      "word_top": " sure",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I am sure that these ideas help many people.",
    "sentence_len": 4
  },
  "293": {
    "sententce_ID": 293,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "do\u3000eat",
      "word_bottom": "eat"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "sushi"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "because I like raw fish",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I eat sushi because I like raw fish.",
    "sentence_len": 4
  },
  "294": {
    "sententce_ID": 294,
    "1": {
      "word": "",
      "word_top": "We",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "can\u3000go",
      "word_bottom": "can go"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "to",
      "word_bottom": " the amusement park"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "if you have time",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "We can go to the amusement park if you have time.",
    "sentence_len": 4
  },
  "295": {
    "sententce_ID": 295,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": "someone"
    },
    "2": {
      "word": "",
      "word_top": "would\u3000ask",
      "word_bottom": "would ask"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "to help"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "If I were you,",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "If I were you, I would ask someone to help.",
    "sentence_len": 4
  },
  "296": {
    "sententce_ID": 296,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "do\u3000think",
      "word_bottom": "think"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "that your pencil case is nice"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I think that your pencil case is nice.",
    "sentence_len": 3
  },
  "297": {
    "sententce_ID": 297,
    "1": {
      "word": "",
      "word_top": "Athletes",
      "word_bottom": "us"
    },
    "2": {
      "word": "",
      "word_top": "do\u3000show",
      "word_bottom": "show"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "that we can do anything"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "Athletes show us that we can do anything.",
    "sentence_len": 3
  },
  "298": {
    "sententce_ID": 298,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "do\u3000go",
      "word_bottom": "went"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "to",
      "word_bottom": "the hospital"
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "because I felt sick",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "I went to the hospital because I felt sick. ",
    "sentence_len": 4
  },
  "299": {
    "sententce_ID": 299,
    "1": {
      "word": "",
      "word_top": "We",
      "word_bottom": ""
    },
    "2": {
      "word": "",
      "word_top": "will\u3000go",
      "word_bottom": "will go"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "snowboarding"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "if it snows tomorrow",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "We will go snowboarding if it snows tomorrow.",
    "sentence_len": 4
  },
  "300": {
    "sententce_ID": 300,
    "1": {
      "word": "",
      "word_top": "I",
      "word_bottom": "with him"
    },
    "2": {
      "word": "",
      "word_top": "could\u3000do",
      "word_bottom": "could do"
    },
    "3": {
      "word": "",
      "word_top": "",
      "word_bottom": "a lot of things"
    },
    "4": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "5": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "6": {
      "word": "",
      "word_top": "",
      "word_bottom": ""
    },
    "7": {
      "word": "",
      "word_top": "If  I had a brother,",
      "word_bottom": ""
    },
    "interrogative_sentence": "",
    "completed_english_sentence": "If I had a brother, I could do a lot of things with him.",
    "sentence_len": 4
  },
}
